import React from "react";
import Grid from "@material-ui/core/Grid";
import useStyles from "Components/Pages/UserProfile/UserProfile/UserProfileTabs/StatementsTab/PayPeriodHeader/styles";
import PayGroupSelector from "./PayGroupSelector/PayGroupSelector";
import PayPeriodSelector from "Components/Pages/UserProfile/UserProfile/UserProfileTabs/StatementsTab/PayPeriodHeader/PayPeriodSelector/PayPeriodSelector";
import { DPPartialPayPeriod } from "Shared/types/EmployeeProfiles";

export interface PayGroupPeriodHeaderProps {
  payGroupIndex: number;
  payGroups: string[];
  onPayGroupIndexChanged: (index: number) => void;
  payPeriodIndex: number;
  payPeriods: DPPartialPayPeriod[];
  onPayPeriodIndexChanged: (index: number) => void;
}

const PayGroupPeriodHeader = (props: PayGroupPeriodHeaderProps) => {
  const classes = useStyles();
  const hasMultiplePaygroups = props.payGroups.length > 1;
  return (
    <Grid
      container
      id="pay-period-header"
      className={classes.payPeriodControls}
    >
      <Grid item container xs={12} justify="center">
        {hasMultiplePaygroups && (
          <PayGroupSelector
            selectedIndex={props.payGroupIndex}
            payGroups={props.payGroups}
            onIndexChanged={props.onPayGroupIndexChanged}
          />
        )}

        <PayPeriodSelector
          selectedIndex={props.payPeriodIndex}
          payPeriods={props.payPeriods}
          onIndexChanged={props.onPayPeriodIndexChanged}
        />
      </Grid>
    </Grid>
  );
};

export default PayGroupPeriodHeader;
